import React from "react";

export default function VehicleAttributes({attributes,
                                              onlyKeyAttributes = false,
                                              className = 'listing-feature pr-4',}) {

    const list = onlyKeyAttributes
        ? attributes.filter((attr) => attr.keyAttribute)
        : attributes;

    return (
        <>
            {list.map((attr) => (
                <div key={attr.name} className={className}>
                    <span className="caption">{attr.name}:</span> <span className="value">{attr.value}</span>{attr.unit != null && <span className="value"> {attr.unit}</span>}
                </div>
            ))}
        </>
    );
}